export const AGENT_SESSIONS_ONBOARDING_STATE_KEYS = {
	HAS_OPENED_AGENT_SESSION_FOR_YOU: 'agent-sessions:hasOpenedAgentSessionForYou',
	HAS_OPENED_AGENT_SESSION_RECENT: 'agent-sessions:hasOpenedAgentSessionRecent',
} as const;

export const AgentSessionsOnboardingKeys: readonly (
	| 'agent-sessions:hasOpenedAgentSessionForYou'
	| 'agent-sessions:hasOpenedAgentSessionRecent'
)[] = Object.values(AGENT_SESSIONS_ONBOARDING_STATE_KEYS);

export const AGENT_MENTIONS_ONBOARDING_STATE_KEYS = {
	EDITOR_MENTION_POPUP_OPEN_COUNT: 'agent-mentions:editorMentionPopupOpenCount',
} as const;

export const AgentMentionsOnboardingKeys: readonly 'agent-mentions:editorMentionPopupOpenCount'[] =
	Object.values(AGENT_MENTIONS_ONBOARDING_STATE_KEYS);
